import { FaCheckCircle } from "react-icons/fa";

import GradientBackground from "~/components/GradientBackground";
import { useOnboarding } from "~/hooks";

const CHECKLIST = [
	{
		label: "Your profession",
		description: "Applies the right accreditations to your credits",
	},
	{
		label: "Your learning goal",
		description: "Certification track or CEU renewal — your choice",
	},
	{
		label: "Topics you care about",
		description: "Surfaces relevant content as you go",
	},
];

const OnboardingWizardStepWelcome = () => {
	const { setStep } = useOnboarding();

	return (
		<GradientBackground>
			<div className="flex h-full w-full flex-col items-center justify-center gap-10 px-6 py-16">
				<div className="flex flex-col items-center justify-center gap-10">
					<div className="flex flex-col items-center gap-8 text-center">
						<h1 className="font-bold phablet:text-4xl text-3xl text-white leading-tight">
							Welcome to the Brookbush Institute
						</h1>

						<p className="max-w-md text-base text-sky-100">
							Let's build your personalised learning plan
						</p>
					</div>

					<ul className="flex w-full max-w-sm flex-col gap-4">
						{CHECKLIST.map(({ label, description }) => (
							<li key={label} className="flex items-start gap-3">
								<FaCheckCircle className="mt-1 shrink-0 text-white" size={18} />
								<div className="flex flex-col gap-0.5">
									<span className="font-medium text-white">{label}</span>
									<span className="text-sky-200 text-sm">{description}</span>
								</div>
							</li>
						))}
					</ul>

					<button
						type="button"
						onClick={() => setStep("profession")}
						className="flex items-center justify-center gap-2 rounded-full bg-white px-8 py-3 font-semibold text-slate-900 shadow-black/20 shadow-lg transition hover:bg-slate-100 active:scale-[0.98]"
					>
						Get Started
					</button>
				</div>
			</div>
		</GradientBackground>
	);
};

export default OnboardingWizardStepWelcome;
